export default __webpack_public_path__ + "static/media/v-tb-r.1e016f7f.png";